import { useDataTableContext } from "pages/gdt/store/DataTableProvider";
import { useState } from "react";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";
import { addUtilityToastSuccess } from "utils/addUtilityToastSuccess";
import { ReactComponent as addRow } from "assets/addRow.svg";
import { ButtonIconPermissioned } from "components/ButtonIconPermissioned/ButtonIconPermissioned";

export interface QuickActionInsertRowProps {
  tableId: string;
}
export const QuickActionInsertRow = ({
  tableId,
}: QuickActionInsertRowProps) => {
  const createRows = useDataTableContext((s) => s.createRows);
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    const { error } = await createRows({
      tableId,
      numRows: 1,
    });
    setIsLoading(false);

    if (error === undefined) {
      addUtilityToastSuccess("Row inserted");
    } else {
      addUtilityToastFailure("Failed to insert row");
    }
  };

  return (
    <ButtonIconPermissioned
      requiredPermission="edit"
      defaultTooltip="Insert row"
      aria-label="Insert row"
      size="xs"
      iconType={addRow}
      onClick={() => void handleClick()}
      isLoading={isLoading}
      id={"quickActionInsertRow"}
    />
  );
};
